<template>
  <Modal :title="modalTitle" @backdrop-click="closeModal">
    <template slot="body">
      <div class="form-group">
        <label>Количество<span class="field__label_required">*</span></label>
        <input
          v-focus
          maxlength="6"
          @keypress="isNumber($event)"
          v-model="count"
          class="form-control"
          placeholder="Введите количество"
        />
      </div>
      <div v-if="operationType === 'transfer'">
        <TransferrerField
          class="form-group"
          :value="transferrer"
          :init-type="transferrerType"
          @on-delete="transferrer = null"
          @on-set="(value) => transferrer = value"
        />
        <CurrentUserField
          class="form-group"
          :value="current_user"
          @on-delete="current_user = null"
          @on-set="(value) => current_user = value"
        />
      </div>
      <div>
        <div class="field__label_operation-description">
          <label>Описание</label>
          <span class="label__notice">
            (При отсутствии значения автоматически запишется "{{ getRow(generalDescription) }}")
          </span>
        </div>
        <textarea
          maxlength="50"
          class="form-control textarea_operation_description"
          v-model.trim="operation_description"
        />
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            class="modal-default-button btn btn-danger buttons__button_close-modal"
            @click="closeModal"
          >
            Отмена
          </button>
        </div>
        <div>
          <button
            :disabled="submitWasDisabled"
            class="modal-default-button btn btn-success"
            @click="submit"
          >
            {{submitButtonText}}
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import store from "@/stock/store";
import Modal from "@/_shared/components/ui/Modal";
import CurrentUserField from "@/stock/features/stock-movement/CurrentUserField";
import TransferrerField from "@/stock/features/stock-movement/TransferrerField";
import { generators } from "@/_shared/utils";
import {
  useNotification,
  usePagination,
  useInputValidator,
  useTableHelper,
} from "@/_shared/mixins";
export default {
  mixins: [
    useNotification,
    usePagination,
    useInputValidator,
    useTableHelper,
  ],
  emits: [
    "close",
    "add",
    "edit",
  ],
  components: {
    Modal,
    CurrentUserField,
    TransferrerField,
  },
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      count: 1,
      operation_description: '',
      current_user: null,
      transferrer: null,
    };
  },
  mounted() {
    document.querySelector('body').style.overflow = 'hidden';
  },
  watch: {
    item: {
      handler(newValue) {
        if (!newValue) {
          return;
        }
        const possibleExistedValues = [
          'count',
          'operation_description',
          'current_user',
          'transferrer',
        ];
        possibleExistedValues.forEach((possibleValue) => {
          if (newValue.hasOwnProperty(possibleValue)) {
            this[possibleValue] = newValue[possibleValue];
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    transferrerType() {
      if (!!this.transferrer) {
        return this.transferrer.foreign_key;
      }
    },
    operationType() {
      return store.state.newOperations.operationType;
    },
    generalDescription() {
      return store.state.newOperations.generalDescription;
    },
    submitWasDisabled() {
      if (this.operationType === 'transfer') {
        return !!(!this.current_user || !this.transferrer);
      }
      return !!(this.count.length < 1);
    },
    submitButtonText() {
      return this.isEditOperation ? 'Сохранить' : 'Добавить';
    },
    modalTitle() {
      const { name } = this.item;
      if (this.isEditOperation) {
        const editTitle = `Редактирование операции для "${name}"`;
        return editTitle;
      }
      const addTitle = `Новая операция для "${name}"`;
      return addTitle;
    },
    isEditOperation() {
      return !!(this.item.count);
    },
  },
  methods: {
    setSelectedOperation(value) {
      this.selectedOperation = value;
    },
    submit() {
      const operationItem = {
        id: this.item.id,
        count: this.count,
        name: this.item.name,
        type: this.item.type,
        operation_description: this.operation_description,
        created_at: this.item.created_at,
        transferrer: this.transferrer || null,
        current_user: this.current_user || null,
        listHash: this.item.listHash || generators.generateRandomString(),
      };
      if (this.item.type === 'продукт') {
        operationItem.parent_id = this.item.parent_id || null;
      }
      const actionName = this.isEditOperation ? 'edit' : 'add';
      this.$emit(actionName, operationItem);
      this.closeModal();
    },
    closeModal() {
      this.count = 1;
      this.operation_description = '';
      document.querySelector('body').style.overflow = 'auto';
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
  .textarea_operation_description {
    resize: none;
  }

  .field__label_operation-description {
    display: inline-flex;
    flex-direction: column;
  }

  .field__label_operation-description > .label__notice {
    font-size: 0.8em;
  }

  .form__value_from-pop-up {
    display: grid;
    grid-template-columns: 90% auto;
    column-gap: 0.4em;
  }
</style>



// WEBPACK FOOTER //
// src/stock/widgets/new-operations/AddingItemModal.vue